// extracted by mini-css-extract-plugin
module.exports = {"signup":"Signup-button_signup__1BrHf"};